import React, { useState, useEffect, useRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import CommentForm from 'root/src/client/web/form/FormModule/CommentForm'
import TextField from 'root/src/client/web/form/TextFields/MuiStyledTextField'
import { errorColor } from 'root/src/client/web/commonStyles'

const style = {
	field: {
		margin: 0,
		padding: 0,
		position: 'relative',
		height: 40,
		flex: 1,
	},
	error: {
		margin: [[8, 0]],
		color: errorColor,
	},
}

const ReplyForm = ({
	classes, open, creatorData, addCommentReply,
	messageId, setReplyFormOpen, setRepliesOpen, repliesOpen,
	startInput, isMobileRes,
}) => {
	const [input, setInput] = useState(startInput)
	const [error, setError] = useState('')
	const inputRef = useRef()

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus()
		}
	}, [open])

	return (
		<CommentForm
			creatorData={creatorData}
			isMobileRes={isMobileRes}
			setReplyFormOpen={setReplyFormOpen}
			isReply
			displayForm={open}
			formSubmitError={error}
			submitForm={async () => {
				if (input !== startInput && input.length) {
					setError('')
					const {
						statusCode,
						generalErrors,
						error: { message },
					} = await addCommentReply({ message: input, messageId })
					if (statusCode === 200) {
						setReplyFormOpen(false)
						if (!repliesOpen) {
							setRepliesOpen(true)
						}
						setInput(startInput)
					} else if (statusCode === 403) {
						setError(message)
					} else {
						setError(generalErrors)
					}
				}
			}}
		>
			<div className={classes.field}>
				<TextField
					inputRef={inputRef}
					fieldValue={input}
					setInput={setInput}
					autoComplete="off"
					fieldPlaceholder="Add reply..."
				/>
			</div>
		</CommentForm>
	)
}

export default withStyles(style, { name: 'MuiReplyForm' })(ReplyForm)
